module.exports = __webpack_public_path__ + "static/media/cappello.1d7d69e9.png";